import type { IOrganizationEnterprise } from './OrganizationEnterprise.interface';

export default class OrganizationEnterprise implements IOrganizationEnterprise {
  managingAgents: any;
  lenderCommissions: any;
  branding: {
    enforceGroups: boolean,
    enforceBranches: boolean,
    groupsInheritInApplication: boolean,
    groupsInheritInPortals: boolean,
    branchesInheritInApplication: boolean,
    branchesInheritInPortals: boolean
  };

  permissions: {
    enforcePasswordPolicy: boolean,
    enforcePermissions: boolean,
    enforceVisibility: boolean
  };

  features: {
    clientPortal: boolean,
    connect: boolean,
    diversification: boolean,
    marketing: boolean,
    partnerPortal: boolean
  };

  licenses: {
    account: {
      int1: string,
      idt1: string,
      int2: string,
      idt2: string,
      int3: string,
      idt3: string,
      int4: string,
      idt4: string,
      int5: string,
      idt5: string,
      int6: string,
      idt6: string
    },
    organization: {
      int1: string,
      idt1: string,
      int2: string,
      idt2: string,
      int3: string,
      idt3: string,
      int4: string,
      idt4: string,
      int5: string,
      idt5: string,
      int6: string,
      idt6: string
    }
  };

  brokerTools: {
    uniqueCommissionGroups: boolean
  };

  templates: {
    uniqueTask: boolean,
    uniqueMerge: boolean,
    uniqueRequiredDocuments: boolean,
    uniqueExternalNotifications: boolean,
    uniqueCallScripts: boolean
  };

  process: {
    uniqueLabels: boolean,
    uniqueCustomFields: boolean,
    uniqueWorkflows: boolean
  };

  integrations: {
    allowCampaignMonitor: boolean,
    allowMailChimp: boolean
  };

  additionalEmailText: {
    userAdded: string
  };

  static build = (data: IOrganizationEnterprise) => new OrganizationEnterprise(data);
  static blank = () => new OrganizationEnterprise();

  /**
   * Constructor
   * @param {IOrganizationEnterprise} data
   */
  constructor(data?: IOrganizationEnterprise) {
    this.managingAgents = data?.managingAgents || undefined;
    this.lenderCommissions = data?.lenderCommissions || undefined;
    this.branding = {
      enforceGroups: data?.branding?.enforceGroups === true,
      enforceBranches: data?.branding?.enforceBranches === true,
      groupsInheritInApplication: data?.branding?.groupsInheritInApplication === true,
      groupsInheritInPortals: data?.branding?.groupsInheritInPortals === true,
      branchesInheritInApplication: data?.branding?.branchesInheritInApplication === true,
      branchesInheritInPortals: data?.branding?.branchesInheritInPortals === true
    };
    this.permissions = {
      enforcePasswordPolicy: data?.permissions?.enforcePasswordPolicy === true,
      enforcePermissions: data?.permissions?.enforcePermissions === true,
      enforceVisibility: data?.permissions?.enforceVisibility === true
    };
    this.features = {
      clientPortal: data?.features?.clientPortal === true,
      connect: data?.features?.connect === true,
      diversification: data?.features?.diversification === true,
      marketing: data?.features?.marketing === true,
      partnerPortal: data?.features?.partnerPortal === true
    };
    this.licenses = {
      account: {
        int1: data?.licenses?.account?.int1 || undefined,
        idt1: data?.licenses?.account?.idt1 || undefined,
        int2: data?.licenses?.account?.int2 || undefined,
        idt2: data?.licenses?.account?.idt2 || undefined,
        int3: data?.licenses?.account?.int3 || undefined,
        idt3: data?.licenses?.account?.idt3 || undefined,
        int4: data?.licenses?.account?.int4 || undefined,
        idt4: data?.licenses?.account?.idt4 || undefined,
        int5: data?.licenses?.account?.int5 || undefined,
        idt5: data?.licenses?.account?.idt5 || undefined,
        int6: data?.licenses?.account?.int6 || undefined,
        idt6: data?.licenses?.account?.idt6 || undefined
      },
      organization: {
        int1: data?.licenses?.organization?.int1 || undefined,
        idt1: data?.licenses?.organization?.idt1 || undefined,
        int2: data?.licenses?.organization?.int2 || undefined,
        idt2: data?.licenses?.organization?.idt2 || undefined,
        int3: data?.licenses?.organization?.int3 || undefined,
        idt3: data?.licenses?.organization?.idt3 || undefined,
        int4: data?.licenses?.organization?.int4 || undefined,
        idt4: data?.licenses?.organization?.idt4 || undefined,
        int5: data?.licenses?.organization?.int5 || undefined,
        idt5: data?.licenses?.organization?.idt5 || undefined,
        int6: data?.licenses?.organization?.int6 || undefined,
        idt6: data?.licenses?.organization?.idt6 || undefined
      }
    };
    this.brokerTools = {
      uniqueCommissionGroups: data?.brokerTools?.uniqueCommissionGroups === true
    };
    this.templates = {
      uniqueTask: data?.templates?.uniqueTask === true,
      uniqueMerge: data?.templates?.uniqueMerge === true,
      uniqueRequiredDocuments: data?.templates?.uniqueRequiredDocuments === true,
      uniqueExternalNotifications: data?.templates?.uniqueExternalNotifications === true,
      uniqueCallScripts: data?.templates?.uniqueCallScripts === true
    };
    this.process = {
      uniqueLabels: data?.process?.uniqueLabels === true,
      uniqueCustomFields: data?.process?.uniqueCustomFields === true,
      uniqueWorkflows: data?.process?.uniqueWorkflows === true
    };
    this.integrations = {
      allowCampaignMonitor: data?.integrations?.allowCampaignMonitor === true,
      allowMailChimp: data?.integrations?.allowMailChimp === true
    };
    this.additionalEmailText = {
      userAdded: data?.additionalEmailText?.userAdded || undefined
    };
  }
}
